import React from 'react';
import ReactDOM from 'react-dom';

import App from './App';

export default App;

if (typeof document !== 'undefined') {
  const renderMethod = module.hot
    ? ReactDOM.render
    : ReactDOM.hydrate || ReactDOM.render;
  const render = Comp => {
    renderMethod(<Comp />, document.getElementById('root'));
  };

  render(App);
}



// WEBPACK FOOTER //
// /Users/dnlytras/.npm/_npx/11246/lib/node_modules/landr/theme/src/index.js